import { render } from "./DistrictDetail.vue?vue&type=template&id=82b90ac4"
import script from "./DistrictDetail.vue?vue&type=script&lang=js"
export * from "./DistrictDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__